// removed by extract-text-webpack-plugin
module.exports = {"item":"FqWXmcfTjdFFND5i--Nvq","body":"_3bJB2VsFUDWJfwKxYisqK7","rewardImage":"_284AICq70Uy4oTapkbUIwI","contentView":"_3DeAjhbW-pfsqQkYTrLmHo","title":"_1uPhuzgMGbOHoXorCU7sau","duration":"_2t2nzNVe2cbmeXm9AlfEoC","middleView":"_3yJuq6F-dVJaQ9euR8pWGz","dashLine":"_3cTCXvGTvmwpU-Wgl0_asQ","footer":"a56oJCfuOeSyUbs0kPKfr","btn":"_2IEJVgOmYAfdVQunLMuV6x","groupPrice":"_2wm86k6Av8QqeHgn6_jChY","newPrice":"a5TdL_C6y5fvQYGF4TkyZ","oldPrice":"_3tyVTVKsFtQLn_wUNg4hvl","active":"_3bMe_Rbal9po5ldi3WR7EV","customModal":"_20vUVvEN2MmKBxiXfnVAQ4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HomeService/ServiceItem.scss
// module id = 1120
// module chunks = 0